import { useState, useEffect, useMemo } from 'react';
import { addSeconds, intervalToDuration, isBefore } from 'date-fns';

function convertTZ(date, tzString) {
	if (!date || !tzString) {
		return typeof date === 'string' || date instanceof Date ? new Date(date) : new Date();
	}
	return new Date((typeof date === 'string' ? new Date(date) : date).toLocaleString('en-US', { timeZone: tzString }));
}

export const CountdownTimer = ({
  startTime,
  durationInSeconds,
  setIsExpired,
	timezone
}) => {
	const end = useMemo(() => {
		const start = convertTZ(startTime, timezone);
		return addSeconds(start, durationInSeconds);
	}, [startTime, durationInSeconds, timezone]);

  const [remainingSeconds, setRemainingSeconds] = useState(() => intervalToDuration({ start: new Date(), end }));

  useEffect(() => {
    setRemainingSeconds(intervalToDuration({ start: new Date(), end }));

    if (isBefore(end, new Date())) {
      setIsExpired(true);
      return;
    }

    const intervalId = setInterval(() => {
      const now = new Date();

      if (isBefore(end, now)) {
        setIsExpired(true);
        clearInterval(intervalId);
      } else {
        setRemainingSeconds(intervalToDuration({ start: now, end }));
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [end, setIsExpired]);

  return (
    <>
      {`${remainingSeconds?.minutes || '0'}:${remainingSeconds?.seconds?.toString().padStart(2, '0') || '00'}`}
    </>
  );
};
